import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

type TemplateWatcherState = {
  /** סנכרון תבניות פעיל (מציג אינדיקטור ליד הלוגו) */
  isSyncing: boolean;
  /** חותמת זמן אחרי סנכרון מוצלח (למניעת בקשות תכופות מדי) */
  lastSuccessfulSyncAt: number | null;
};

const initialState: TemplateWatcherState = {
  isSyncing: false,
  lastSuccessfulSyncAt: null,
};

const templateWatcherSlice = createSlice({
  name: 'templateWatcher',
  initialState,
  reducers: {
    setTemplateWatcherSyncing(state, action: PayloadAction<boolean>) {
      state.isSyncing = action.payload;
    },
    setTemplateWatcherLastSuccessfulSyncAt(state, action: PayloadAction<number | null>) {
      state.lastSuccessfulSyncAt = action.payload;
    },
  },
});

export const { setTemplateWatcherSyncing, setTemplateWatcherLastSuccessfulSyncAt } = templateWatcherSlice.actions;

export default templateWatcherSlice.reducer;
